export class DroppLocationResponse {

  status: number;
  message: string;
  locations: DroppLocationModel[];

  static generate(json: any): DroppLocationResponse {

    const res = new DroppLocationResponse();
    res.locations = DroppLocationModel.generateList(json['locations']);

    return res;
  }
}

export class DroppLocationModel {

  id: string;
  name: string;
  address: string;
  externalLocationId: string;
  gpsLatitude: string;
  gpsLongitude: string;

  createdAt: Date;
  updatedAt: Date;

  availableAt: string;
  pricetype: 1;

  /**
   * Price which is found based on the article and Dropp's pricing
   */
  price: number;

  /**
   * Only used for home deliveries undefined for all the others
   */
  dayDelivery: boolean = undefined;

  addressObject: {
    street: string,
    zip: number,
    town: string
  } = {
    street: null,
    zip: null,
    town: null
  };

  static generate(json: any): DroppLocationModel {

    const location = new DroppLocationModel();
    location.id = json['id'];
    location.name = json['name'];
    location.address = json['address'];
    location.externalLocationId = json['externalLocationId'];
    location.gpsLatitude = json['gpsLatitude'];
    location.gpsLongitude = json['gpsLongitude'];

    location.createdAt = new Date(json['createdAt']);
    location.updatedAt = new Date(json['updatedAt']);

    location.availableAt = json['availableAt'];
    location.pricetype = json['pricetype'];

    location.addressObject = json['addressObject'];

    return location;

  }

  static generateList(jsonList: any[]): DroppLocationModel[] {

    const list = [];
    for (const json of jsonList) {
      list.push(this.generate(json));
    }

    return list;

  }

}
